import apiClient from './base.api'
const BASE_ENDPOINT = window.config.LOCALIZATIONS_BASE_ENDPOINT

export const fetchLanguagesAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}localizations/languages/`, {
    skipAuth: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return response
}

export const fetchLocalizationsAsync = async(languageCode) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}localizations/?translations__language_code=${languageCode}`, {
    skipAuth: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return response
}
